<frodo-page-shell [goBack]="goBack">
  <div shell-header class="enter-code__header__title" data-testid="enterCodeTitle">
    {{ title | translate }}
  </div>
  <nav shell-header-action>
    <frodo-language-selector></frodo-language-selector>
  </nav>

  <div *ngIf="allowAlphanumeric" class="enter-code">
    <div class="enter-code__control" *ngIf="!showBoxes">
      <input type="text" class="enter-code__control__input" id="code" autoComplete="off" />
    </div>
    <div class="enter-code__boxes-container" *ngIf="showBoxes">
      <frodo-boxes-input
        [allowAlphanumeric]="allowAlphanumeric"
        [boxesLength]="boxesLength"
        (onFocusEvent)="receiveOnFocusEvent($event)"
      >
      </frodo-boxes-input>
    </div>
    <frodo-alpha-keyboard
      [viewType]="viewType"
      [side]="'FRONT'"
      [globalIsLoading]="isLoading"
      (valueSubmit)="handleSubmit($event)"
    ></frodo-alpha-keyboard>
  </div>

  <div *ngIf="!allowAlphanumeric" class="enter-code">
    <div class="enter-code__control" *ngIf="!showBoxes">
      <input type="text" class="enter-code__control__input" id="code" autocomplete="off" />
    </div>

    <div class="enter-code__boxes-container" *ngIf="showBoxes">
      <frodo-boxes-input
        [allowAlphanumeric]="allowAlphanumeric"
        [boxesLength]="boxesLength"
        (onFocusEvent)="receiveOnFocusEvent($event)"
        (onChangeEvent)="receiveOnChangeEvent($event)"
      >
      </frodo-boxes-input>
    </div>

    <frodo-numeric-keyboard
      [viewType]="viewType"
      [side]="'FRONT'"
      [globalIsLoading]="isLoading"
      (valueSubmit)="handleSubmit($event)"
    ></frodo-numeric-keyboard>
  </div>
</frodo-page-shell>
